import {AuthSystem} from './auth-system'

// Funzione per ottenere l'URL di login corrente
export const getCurrentLoginUrl = (): string => {
  const authSystem = AuthSystem.getInstance()
  return authSystem.getCurrentLoginUrlFull()
}

// Funzione per ottenere l'URL di login relativo
export const getCurrentLoginUrlRelative = (): string => {
  const authSystem = AuthSystem.getInstance()
  return authSystem.getCurrentLoginUrl()
}

// Funzione per mostrare l'URL di login nella console
export const showCurrentLoginUrl = (): void => {
  const loginUrl = getCurrentLoginUrl()
  console.log('🔗 URL di login corrente:', loginUrl)
  console.log('📅 Questo URL è valido per 12 ore')
  console.log('⏰ Generato il:', new Date().toLocaleString('it-IT'))
}

// Funzione per copiare l'URL negli appunti (se supportato)
export const copyLoginUrlToClipboard = async (): Promise<void> => {
  try {
    const loginUrl = getCurrentLoginUrl()
    await navigator.clipboard.writeText(loginUrl)
    console.log('✅ URL copiato negli appunti:', loginUrl)
  } catch (error) {
    console.error('❌ Errore nel copiare l\'URL:', error)
    // Fallback per browser che non supportano clipboard API
    const textArea = document.createElement('textarea')
    textArea.value = getCurrentLoginUrl()
    document.body.appendChild(textArea)
    textArea.select()
    document.execCommand('copy')
    document.body.removeChild(textArea)
    console.log('✅ URL copiato negli appunti (fallback):', getCurrentLoginUrl())
  }
}

// Funzione per mostrare informazioni complete sull'autenticazione
export const showAuthInfo = (): void => {
  const authSystem = AuthSystem.getInstance()
  const authStatus = authSystem.getAuthStatus()
  
  console.log('🔐 Informazioni di autenticazione:')
  console.log('   - Autenticato:', authStatus.isAuthenticated)
  console.log('   - URL di login completo:', getCurrentLoginUrl())
  console.log('   - URL di login relativo:', getCurrentLoginUrlRelative())
  
  if (authStatus.tokenExpiresAt) {
    console.log('   - Token scade:', new Date(authStatus.tokenExpiresAt).toLocaleString('it-IT'))
  }
  
  if (authStatus.urlExpiresAt) {
    console.log('   - URL scade:', new Date(authStatus.urlExpiresAt).toLocaleString('it-IT'))
  }
}

// Funzione per testare un URL di login specifico
export const testLoginUrl = (url: string): void => {
  const authSystem = AuthSystem.getInstance()
  const isValid = authSystem.isLoginUrlValid(url)
  
  console.log('🧪 Test URL di login:', {
    url: url,
    isValid: isValid,
    currentUrl: authSystem.getCurrentLoginUrl(),
    currentUrlFull: authSystem.getCurrentLoginUrlFull()
  })
} 